export default __webpack_public_path__ + "static/media/ss2.7257687b.jpg";